<template>
    <div>

        <div class="row">
            <div class="col-md-12">
                <div v-if="showReceiptBucket == false && showInstitutionalDocuments == false && showBrowseDevice == false ">
                    <div style="margin-bottom:15px;">
                        <button type="button" class="btn btn-primary" @click="getReceipts()">
                            Receipt Bucket
                        </button>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary" @click="getInstitutionalDocuments()">
                            Institutional Documents
                        </button>
                    </div>
                </div>

                <!-- receipt bukcet -->
                <div v-if="showReceiptBucket">
                    <div style="margin-bottom:10px;">
                        Select Attachment
                        <b-spinner small v-if="receiptsLoading" variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <div class="thumbnail-container" v-if="!receiptsLoading">
                        <!-- Do google doc stuff here -->
                        <div v-for="r in rows" class="card-styling" :key="r.expenseReportId" @click="addRemoveFromSelectedReceipt(r)" v-bind:class="{'selectedReceipt':r.selected}">
                            <div style="min-height:150px; max-height:150px;" class="img-center-vertically">
                                <img class="img" v-bind:src="r.thumbnailUrl" referrerpolicy="no-referrer"/>
                            </div>
                            <div class="card-description">
                                <div class="receipt-name" v-bind:title="r.receiptName">
                                    {{r.receiptName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Instituational Documents -->
                <div v-if="showInstitutionalDocuments">
                    <div style="margin-bottom:10px;">
                        Select Attachment
                        <b-spinner small v-if="receiptsLoading" variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <div class="thumbnail-container" v-if="!receiptsLoading">
                        <!-- Do google doc stuff here -->
                        <div v-for="r in rowDataInstitutionalDocuments" :key="r.institutionalDocumentId" class="card-styling" @click="addRemoveFromSelectedReceipt(r)" v-bind:class="{'selectedReceipt':r.selected}">
                            <div style="min-height:150px; max-height:150px;" class="img-center-vertically">
                                <img class="img" v-bind:src="r.thumbnailUrl" referrerpolicy="no-referrer" />
                            </div>
                            <div class="card-description">
                                <div class="receipt-name" v-bind:title="r.institutionalDocumentName">
                                    {{r.institutionalDocumentName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Upload direct here -->
                <div v-if="showReceiptBucket == false && showInstitutionalDocuments == false ">
                    <div class="example-simple">
                        <div class="upload">
                            <div class="upload-button">
                                <file-upload class="btn btn-primary upload-button"
                                             :post-action="this.receiptURL"
                                             extensions="gif,jpg,jpeg,png,webp,pdf,doc,docx,csv,xlsx"
                                             accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,image/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                             :multiple="true"
                                             :headers="{'Authorization': 'Bearer ' + this.msal.accessToken}"
                                             v-model="files"
                                             input-id="file1"
                                             @input-filter="inputFilter"
                                             @input-file="inputFile"
                                             :drop="true"
                                             ref="upload">
                                    Browse Device
                                </file-upload>
                                <button type="button" class="btn btn-success upload-button" style="display:none;" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                    Start Upload
                                </button>
                                <button type="button" class="btn btn-danger upload-button" v-else @click.prevent="$refs.upload.active = false">
                                    <i class="fa fa-stop" aria-hidden="true"></i>
                                    Stop Upload
                                </button>
                            </div>
                        </div>
                    </div>
                    <ul>
                        <li v-for="file in files" :key="file.id">
                            <span v-if="file.error">Error uploading file: {{file.name}} Error: {{file.error}}</span>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>


</template>


<style scoped>
    ul {
        list-style: none;
    }

    .upload-button {
        margin-top: 10px;
    }

    .thumbnail-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        max-height: 400px;
        overflow-y: scroll;
    }

    .example-simple label.btn {
        margin-bottom: 0;
        margin-right: 1rem;
    }

    input:disabled {
        background: none;
    }

    .card-styling {
        border: 1px solid #151616;
        border-radius: 3px;
        margin-bottom: 20px;
        margin-right: 5px;
    }

    .icons {
        color: grey;
        cursor: pointer;
        font-size: 1.25em;
    }

        .icons:hover {
            color: #12bbad;
        }

    svg:hover {
        fill: red;
    }

    .card-description {
        border-top: 1px solid #d0d2d7;
        height: 65px;
        max-width: 125px;
        text-align: center;
    }

    .img-center-vertically {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .img {
        width: 125px;
        max-height: 150px;
        cursor: pointer;
    }

    .receipt-name {
        max-height: 3.3em;
        overflow: hidden;
        font-weight: 500;
        font-size: smaller;
    }

    .selectedReceipt {
        border: 5px solid #4f70ce;
    }
</style>

<script>
    import FileUpload from 'vue-upload-component'

    export default {
        name: 'AttachmentComponent',
        components: {
            FileUpload
        },
        props: {
            "expenseReportId": { default: null },
            "title": { default: "" },
            "attachments": { default: [] },
        },
        data() {
            return {
                rowData: [],
                rowDataInstitutionalDocuments: [],
                files: [],
                receiptURL: this.$hostname + 'receipts',
                showReceiptBucket: false,
                showInstitutionalDocuments: false,
                showBrowseDevice: false,
                receiptsLoading: true
            }
        },
        methods: {
            //sanitize input filter for upload client side
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },

            //event triggers on upload
            inputFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    if (newFile && !oldFile) {
                        // add
                    }
                    if (newFile && oldFile) {
                        // update
                    }
                    if (!newFile && oldFile) {
                        // remove
                    }
                    // Uploaded successfully
                    if (newFile.success !== oldFile.success) {
                        console.log(newFile)
                        this.attachments.push({
                            attachmentId: newFile.response[0].id,
                            attachmentName: newFile.response[0].receiptName,
                            attachmentTypeId: 1,
                        })

                        this.$emit('fileUploadDone', true);
                    }
                }

                // Automatically activate upload
                if (newFile !== oldFile || oldFile.error !== newFile.error) {

                    if (!this.$refs.upload.active) {
                        this.$refs.upload.active = true
                    }
                }

            },
            addRemoveFromSelectedReceipt(receipt) {
                //determine the type of receipt by searching if property exists on param passed through.
                let attachmentTypeId = receipt.receiptName ? 1 : 2;

                let existingIndex = this.getReceiptBucketAttachmentIndex(this.attachments, receipt.id, attachmentTypeId);

                if (existingIndex != -1) {
                    this.attachments.splice(existingIndex, 1);
                    receipt.selected = false;
                }
                else {
                    this.attachments.push({
                        attachmentName: receipt.receiptName || receipt.institutionalDocumentName,
                        attachmentId: receipt.id,
                        attachmentTypeId: attachmentTypeId,
                    })
                    receipt.selected = true;
                }
            },
            getReceiptBucketAttachmentIndex: function (attachments, id, attachmentTypeId) {
                return _.findIndex(attachments, { 'attachmentId': id, 'attachmentTypeId': attachmentTypeId });
            },
            async getReceipts() {
                this.receiptsLoading = true;

                this.$http
                    .get('receipts', {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        let merged = this.mergeById(response.data, this.rowData);

                        let promises = [];
                        merged.forEach((item) => {

                            //if thumbnail exists dont grab it again
                            if (!item.thumbNail) {
                                promises.push(this.getThumbnailBase64(item.id)
                                    .then((b64) => {
                                        item.thumbNail = b64
                                        return this.rowData.push(item)
                                    }
                                    ))
                            }
                        })

                        Promise.all(promises).
                            then(() => {

                                merged.forEach(m => {
                                    if (_.some(this.attachments, function (a) { return m.id == a.attachmentId })) {
                                        this.$set(m, 'selected', true)
                                    }
                                    else {
                                        this.$set(m, 'selected', false)
                                    }
                                })

                                //update list with merged data
                                this.rowData = merged;

                                //order by id
                                this.rowData.sort(function (a, b) {
                                    return b.id - a.id;
                                });

                                this.receiptsLoading = false;

                            })
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => {
                        this.showReceiptBucket = true;
                        //this.receiptsLoading = false;
                    }
                    )
            },
            async getInstitutionalDocuments() {
                this.receiptsLoading = true;

                this.$http
                    .get('InstitutionalDocuments', {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        let merged = this.mergeById(response.data, this.rowDataInstitutionalDocuments);

                        let promises = [];
                        merged.forEach((item) => {

                            //if thumbnail exists dont grab it again
                            if (!item.thumbNail) {
                                promises.push(this.getInstitutionalDocumentThumbnailBase64(item.id)
                                    .then((b64) => {
                                        item.thumbNail = b64
                                        console.log(b64)
                                        return this.rowDataInstitutionalDocuments.push(item)
                                    }
                                    ))
                            }
                        })

                        Promise.all(promises).
                            then(() => {

                                merged.forEach(m => {
                                    if (_.some(this.attachments, function (a) { return m.id == a.attachmentId })) {
                                        this.$set(m, 'selected', true)
                                    }
                                    else {
                                        this.$set(m, 'selected', false)
                                    }
                                })

                                //update list with merged data
                                //this.rowDataInstitutionalDocuments = merged;

                                //order by id
                                this.rowDataInstitutionalDocuments.sort(function (a, b) {
                                    return b.id - a.id;
                                });

                                console.log(this.rowDataInstitutionalDocuments)

                                this.receiptsLoading = false;

                            })
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => {
                        this.showInstitutionalDocuments = true;
                        //this.receiptsLoading = false;
                    }
                    )
            },
            //gets image thumbnail
            async getThumbnailBase64(id) {
                var thumbnailUrl = 'receipts/' + id + '/Download/Thumbnail'
                return await this.$http
                    .get(thumbnailUrl, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        var thumbNailb64 = 'data:' + response.data.mimeType + ';base64,' + response.data.file;

                        return thumbNailb64;
                    })
                    .catch(() => {
                        //handle case for when thumbnail doesnt exist
                        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4woCATAGi1rqVwAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAABIJJREFUeF7tnU1r1FAYhftrBubHtdOBliSdxVTcVEHQhcuKGxdSBHUlogvBhZZCdSOuRezP0PN6r4u5k9pMPpq57zkPHILz8Sbn+gxRJk132nBwcPD0+Pj4t1KbJ8gkLpVPJMCN8S2BBGgUvxJIgMbxKUGdAGVZXu3t7b1lSlEU39N1qIk/CeoEsMfi0zSg9zJdh2viSwIJEEDvpgJY/EggAQLovYkAFh8SSIAAeq8JUFXVj/SxJPlLIAEC6L0mANbhAlv7S155PEneEkiAAHqvCWD/O8B2gviVQAIE0LtWgPicXwkkQAC9rxXAwJ99SiABAuj9XwEMPOZPAgkQQO8bBTDwuC8JJEAAvRsJYOA5PxJIgAB6NxbAwPM+JJAAAfTeSAADr8lfAgkQQO+NBTDwurwlkAAB9G4lgIHX5iuBBAigd2sBDLw+TwkkQAC9Owlg4D35SSABAujdWQAD78tLAgkQQO9eBDDw3nwkkAAB9O5NAAPvz0MCCRBA714FMDBj+yWQAAH07l0AA3O2WwIJEEDvQQQwMGt7JZAAAfQeTAAD87ZTgqEEsCLL5fIuZp3avJ5zarNtH3F3ncGsNQHsB2Rq9t06RVG8Pjo6+pzuJ8ntSmAHlhxAZwGsABbvPJ3bd7CPT9j2sliYsybAiFnGwxqegQS4zcXsZbFsTjJ3tGD9T+NhDY8ECNicZO5o6br+GzGQABOc724613WO11NA9gIYmDP0PwLv2D7i7jpjs2r2M3jwQfn2b93/xR6PhzU8trNRD4Cc0ddfAoyLBCBHApAjAciRAORIAHIkADkSgBwJQI4EIMetAJhjV8Asq6p6UJblQ0+xTtbNOsa6rXEpAGbYBSEf07neEjt2ksCrAFvz1eotpNP1CBIg/0iAFMywU8CXdK63FEVxia1OAXVgzmSxWNyfz+dnyAtnOUO3e9Yx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgzt8LQpxH3wXUgRmTqqrep3O9BR3fYatvA1Mwwz4dKzMdR9cDpGCGBGiIVwHsDiFNfh171ok3d9ApoA7MMQkez2azN3a/PU+xTmVZPrKOsW5r3AogmiEByJEA5EgAciQAORKAHAlAjgQgRwKQIwHIkQDkuBUAc6bIifNMY93WuBQAM6aLxeJDOtdbYsdOEngVwD4dKzMd5yTWboUEyD8SIAUzplVV/Urnegs6/sRWp4A6MGd6eHj4bH9//3w2m114inWybtYx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgju4Q0gCXAmCG3Sr+VTrXW9DxJbb68fAUzLBPx8pMx9ENIlIwQwI0xKsA9itj3F8Qgo52QYhOAXVgzmQ+nz/f3d29RL46y6V1s46xbmvcCiCaIQHIkQDkSAByJAA5EoAcCUCOBCBHApAjAciRAORIAHIkADkSgBwJQI4EIEcCkCMByJEA5EgAcrZSgLIsr+p+XZrSf2yt0/UfXQBl3EgA8kgA8kgA8rQTYGfnD9K0abxUqpkmAAAAAElFTkSuQmCC"
                    })
            },
            async getInstitutionalDocumentThumbnailBase64(id) {
                var thumbnailUrl = 'InstitutionalDocuments/' + id + '/Download/Thumbnail'
                return await this.$http
                    .get(thumbnailUrl, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        var thumbNailb64 = 'data:' + response.data.mimeType + ';base64,' + response.data.file;

                        return thumbNailb64;
                    })
                    .catch(() => {
                        //handle case for when thumbnail doesnt exist
                        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4woCATAGi1rqVwAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAABIJJREFUeF7tnU1r1FAYhftrBubHtdOBliSdxVTcVEHQhcuKGxdSBHUlogvBhZZCdSOuRezP0PN6r4u5k9pMPpq57zkPHILz8Sbn+gxRJk132nBwcPD0+Pj4t1KbJ8gkLpVPJMCN8S2BBGgUvxJIgMbxKUGdAGVZXu3t7b1lSlEU39N1qIk/CeoEsMfi0zSg9zJdh2viSwIJEEDvpgJY/EggAQLovYkAFh8SSIAAeq8JUFXVj/SxJPlLIAEC6L0mANbhAlv7S155PEneEkiAAHqvCWD/O8B2gviVQAIE0LtWgPicXwkkQAC9rxXAwJ99SiABAuj9XwEMPOZPAgkQQO8bBTDwuC8JJEAAvRsJYOA5PxJIgAB6NxbAwPM+JJAAAfTeSAADr8lfAgkQQO+NBTDwurwlkAAB9G4lgIHX5iuBBAigd2sBDLw+TwkkQAC9Owlg4D35SSABAujdWQAD78tLAgkQQO9eBDDw3nwkkAAB9O5NAAPvz0MCCRBA714FMDBj+yWQAAH07l0AA3O2WwIJEEDvQQQwMGt7JZAAAfQeTAAD87ZTgqEEsCLL5fIuZp3avJ5zarNtH3F3ncGsNQHsB2Rq9t06RVG8Pjo6+pzuJ8ntSmAHlhxAZwGsABbvPJ3bd7CPT9j2sliYsybAiFnGwxqegQS4zcXsZbFsTjJ3tGD9T+NhDY8ECNicZO5o6br+GzGQABOc724613WO11NA9gIYmDP0PwLv2D7i7jpjs2r2M3jwQfn2b93/xR6PhzU8trNRD4Cc0ddfAoyLBCBHApAjAciRAORIAHIkADkSgBwJQI4EIMetAJhjV8Asq6p6UJblQ0+xTtbNOsa6rXEpAGbYBSEf07neEjt2ksCrAFvz1eotpNP1CBIg/0iAFMywU8CXdK63FEVxia1OAXVgzmSxWNyfz+dnyAtnOUO3e9Yx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgzt8LQpxH3wXUgRmTqqrep3O9BR3fYatvA1Mwwz4dKzMdR9cDpGCGBGiIVwHsDiFNfh171ok3d9ApoA7MMQkez2azN3a/PU+xTmVZPrKOsW5r3AogmiEByJEA5EgAciQAORKAHAlAjgQgRwKQIwHIkQDkuBUAc6bIifNMY93WuBQAM6aLxeJDOtdbYsdOEngVwD4dKzMd5yTWboUEyD8SIAUzplVV/Urnegs6/sRWp4A6MGd6eHj4bH9//3w2m114inWybtYx1m2NWwFEMyQAORKAHAlAjgQgRwKQIwHIkQDkSAByJAA5EoActwJgju4Q0gCXAmCG3Sr+VTrXW9DxJbb68fAUzLBPx8pMx9ENIlIwQwI0xKsA9itj3F8Qgo52QYhOAXVgzmQ+nz/f3d29RL46y6V1s46xbmvcCiCaIQHIkQDkSAByJAA5EoAcCUCOBCBHApAjAciRAORIAHIkADkSgBwJQI4EIEcCkCMByJEA5EgAcrZSgLIsr+p+XZrSf2yt0/UfXQBl3EgA8kgA8kgA8rQTYGfnD9K0abxUqpkmAAAAAElFTkSuQmCC"
                    })
            },
            //merge old array data into new array data (used to cache the thumbnails ajax call)
            mergeById(a1, a2) {
                return a1.map(itm => ({
                    ...a2.find((item) => (item.id === itm.id) && item),
                    ...itm
                }))
            },
        },
        computed: {
            rows: function () {
                return this.rowData.filter(r => r.expenseReportId == null || (this.expenseReportId && r.expenseReportId == this.expenseReportId));
            }
        },
        mounted() {
        },
        destroyed() {
        }
    }
</script>